<!-- Sve komponente ostaju u DOM-u, samo se sakrivaju/prikazuju za instant prelazak bez treptanja -->

@if (userRole === 'Clinic') {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Cards'">
    <anihis-cards />
  </div>
}

@defer (when loadedTabs().has('Manufacturers of medicaments')) {
  <div
    class="tab-panel"
    [class.tab-panel--active]="tab === 'Manufacturers of medicaments'"
  >
    <anihis-manufacturers-of-medicaments />
  </div>
}

@defer (when loadedTabs().has('Breeds')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Breeds'">
    @if (userRole === 'Administrator') {
      <anihis-species />
    } @else {
      <anihis-species-breeds />
    }
  </div>
}

<!-- @defer (when loadedTabs().has('Excellent vaccinations')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Excellent vaccinations'">
    <anihis-excellent-vaccinations />
  </div>
} -->

@defer (when loadedTabs().has('OwnerNotes')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'OwnerNotes'">
    @if (userRole === 'ClinicOwner') {
      <anihis-owner-notes />
    }
  </div>
}

@defer (when loadedTabs().has('Dashboard')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Dashboard'">
    @if (userRole === 'ClinicOwner') {
      <anihis-dashboard-clinic-owner />
    } @else if (userRole === 'Clinic') {
      <anihis-dashboard-clinic />
    } @else if (userRole === 'Administrator') {
      <anihis-dashboard-admin />
    } @else if (userRole === 'Manager') {
      <anihis-manager-portal-dashboard [active]="tab === 'Dashboard'" />
    }
  </div>
}

@defer (when loadedTabs().has('Manager organizations')) {
  <div
    class="tab-panel"
    [class.tab-panel--active]="tab === 'Manager organizations'"
  >
    @if (userRole === 'Manager') {
      <anihis-manager-organizations [active]="tab === 'Manager organizations'" />
    }
  </div>
}

@defer (when loadedTabs().has('Create organization')) {
  <div
    class="tab-panel"
    [class.tab-panel--active]="tab === 'Create organization'"
  >
    @if (userRole === 'Manager') {
      <anihis-manager-create-organization />
    }
  </div>
}

@defer (when loadedTabs().has('Manager payouts')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Manager payouts'">
    @if (userRole === 'Manager') {
      <anihis-manager-payouts />
    }
  </div>
}

@defer (when loadedTabs().has('Manager hierarchy')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Manager hierarchy'">
    @if (userRole === 'Manager') {
      <anihis-manager-hierarchy [active]="tab === 'Manager hierarchy'" />
    }
  </div>
}

@defer (when loadedTabs().has('Manager audit log')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Manager audit log'">
    @if (userRole === 'Manager') {
      <anihis-manager-audit-log />
    }
  </div>
}

@defer (when loadedTabs().has('At-risk contracts')) {
  <div
    class="tab-panel"
    [class.tab-panel--active]="tab === 'At-risk contracts'"
  >
    @if (userRole === 'Manager') {
      <anihis-manager-at-risk-contracts [active]="tab === 'At-risk contracts'" />
    }
  </div>
}

@defer (when loadedTabs().has('Manager sub-managers')) {
  <div
    class="tab-panel"
    [class.tab-panel--active]="tab === 'Manager sub-managers'"
  >
    @if (userRole === 'Manager') {
      <anihis-manager-subordinates />
    }
  </div>
}

@defer (when loadedTabs().has('Manager notes')) {
  <div
    class="tab-panel"
    [class.tab-panel--active]="tab === 'Manager notes'"
  >
    @if (userRole === 'Manager') {
      <anihis-manager-notes />
    }
  </div>
}

@defer (when loadedTabs().has('Managers to pay')) {
  <div
    class="tab-panel"
    [class.tab-panel--active]="tab === 'Managers to pay'"
  >
    @if (userRole === 'Administrator') {
      <anihis-dashboard-managers-to-pay />
    }
  </div>
}

@defer (when loadedTabs().has('Unassigned contracts')) {
  <div
    class="tab-panel"
    [class.tab-panel--active]="tab === 'Unassigned contracts'"
  >
    @if (userRole === 'Administrator') {
      <anihis-dashboard-unassigned-contracts />
    }
  </div>
}

@defer (when loadedTabs().has('Debts')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Debts'">
    @if (userRole === 'ClinicOwner') {
      <anihis-debts />
    }
  </div>
}

@defer (when loadedTabs().has('ClinicNotes')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'ClinicNotes'">
    @if (userRole === 'Clinic') {
      <anihis-clinic-notes />
    }
  </div>
}

@defer (when loadedTabs().has('All Reports')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'All Reports'">
    @if (userRole === 'Clinic') {
      <anihis-all-reports />
    }
  </div>
}

@defer (when loadedTabs().has('Owners')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Owners'">
    <anihis-owner />
  </div>
}

@defer (when loadedTabs().has('Email')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Email'">
    <anihis-email-editor />
  </div>
}

@defer (when loadedTabs().has('State pharmacy')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'State pharmacy'">
    <anihis-state-pharmacy />
  </div>
}

@defer (when loadedTabs().has('Spending medicaments groups')) {
  <div
    class="tab-panel"
    [class.tab-panel--active]="tab === 'Spending medicaments groups'"
  >
    <anihis-spending-medicaments-groups />
  </div>
}

@defer (when loadedTabs().has('Spending medicaments')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Spending medicaments'">
    <anihis-spending-medicaments />
  </div>
}

@defer (when loadedTabs().has('Procurement')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Procurement'">
    <anihis-procurement />
  </div>
}

@defer (when loadedTabs().has('Price list medicaments')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Price list medicaments'">
    <anihis-price-list-medicaments />
  </div>
}

@defer (when loadedTabs().has('Optimal lager')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Optimal lager'">
    <anihis-optimal-lager />
  </div>
}

@defer (when loadedTabs().has('Obligation of the pharmacy')) {
  <div
    class="tab-panel"
    [class.tab-panel--active]="tab === 'Obligation of the pharmacy'"
  >
    <anihis-obligation-of-the-pharmacy />
  </div>
}

@defer (when loadedTabs().has('Minimal lager')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Minimal lager'">
    <anihis-minimal-lager />
  </div>
}

@defer (when loadedTabs().has('Medicaments output')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Medicaments output'">
    <anihis-medicaments-output />
  </div>
}

@defer (when loadedTabs().has('Dissolution of the pharmacy')) {
  <div
    class="tab-panel"
    [class.tab-panel--active]="tab === 'Dissolution of the pharmacy'"
  >
    <anihis-dissolution-of-the-pharmacy />
  </div>
}

@defer (when loadedTabs().has('Card medicament')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Card medicament'">
    <anihis-card-medicament />
  </div>
}

@defer (when loadedTabs().has('List medicaments')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'List medicaments'">
    <anihis-list-medicaments />
  </div>
}

@defer (when loadedTabs().has('Census differences and bookkeeping')) {
  <div
    class="tab-panel"
    [class.tab-panel--active]="tab === 'Census differences and bookkeeping'"
  >
    <anihis-census-differences-and-bookkeeping />
  </div>
}

@defer (when loadedTabs().has('Veterinarians')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Veterinarians'">
    <anihis-veterinarians />
  </div>
}

@defer (when loadedTabs().has('Settings')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Settings'">
    <anihis-settings />
  </div>
}

@defer (when loadedTabs().has('Support')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Support'">
    <anihis-support />
  </div>
}

@defer (when loadedTabs().has('Managers')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Managers'">
    @if (userRole === 'Administrator') {
      <anihis-managers />
    }
  </div>
}

@defer (when loadedTabs().has('Clinics')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Clinics'">
    @if (userRole === 'Administrator') {
      <anihis-clinic-and-owner-clinic />
    } @else if (userRole === 'ClinicOwner') {
      <anihis-owner-clinics-list />
    }
  </div>
}

@defer (when loadedTabs().has('Ambulances')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Ambulances'">
    @if (userRole === 'ClinicOwner') {
      <anihis-owner-clinics-list />
    }
  </div>
}

@defer (when loadedTabs().has('Groomers')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Groomers'">
    <anihis-groomers />
  </div>
}

@defer (when loadedTabs().has('Pet Transporters')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Pet Transporters'">
    <anihis-pet-transporters />
  </div>
}

@defer (when loadedTabs().has('QR')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'QR'">
    <anihis-qr-code />
  </div>
}

@defer (when loadedTabs().has('System-Diagnoses')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'System-Diagnoses'">
    <anihis-system-diagnoses />
  </div>
}

@defer (when loadedTabs().has('System-Services')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'System-Services'">
    <anihis-system-services />
  </div>
}

@defer (when loadedTabs().has('System-Type-Medicaments')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'System-Type-Medicaments'">
    <anihis-system-type-medicaments />
  </div>
}

@defer (when loadedTabs().has('System-Notifications')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'System-Notifications'">
    <anihis-system-notifications />
  </div>
}

@defer (when loadedTabs().has('Legal-Documents')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Legal-Documents'">
    <anihis-legal-documents />
  </div>
}

@defer (when loadedTabs().has('Video-Tutorials')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Video-Tutorials'">
    @if (userRole === 'Administrator') {
      <anihis-video-tutorials-admin />
    } @else {
      <anihis-video-tutorials />
    }
  </div>
}

@defer (when loadedTabs().has('Diagnoses')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Diagnoses'">
    <anihis-diagnoses />
  </div>
}

@defer (when loadedTabs().has('Services')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Services'">
    <anihis-services />
  </div>
}

@defer (when loadedTabs().has('Medicaments')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Medicaments'">
    <anihis-medicaments />
  </div>
}

@defer (when loadedTabs().has('Hotels')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Hotels'">
    <anihis-hotels />
  </div>
}

@defer (when loadedTabs().has('Others')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Others'">
    <anihis-others />
  </div>
}

@defer (when loadedTabs().has('Clubs')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Clubs'">
    <anihis-clubs />
  </div>
}

@defer (when loadedTabs().has('Walkers')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Walkers'">
    <anihis-walkers />
  </div>
}

@defer (when loadedTabs().has('Stores')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Stores'">
    <anihis-stores />
  </div>
}

@defer (when loadedTabs().has('Pet Insurances')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Pet Insurances'">
    <anihis-pet-insurances />
  </div>
}

@defer (when loadedTabs().has('Promotions')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Promotions'">
    <anihis-promotions />
  </div>
}

@defer (when loadedTabs().has('Trainers')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Trainers'">
    <anihis-trainers />
  </div>
}

@defer (when loadedTabs().has('Interesting')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Interesting'">
    <anihis-interesting-admin />
  </div>
}

@defer (when loadedTabs().has('Tips')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Tips'">
    <anihis-tips-admin />
  </div>
}

@defer (when loadedTabs().has('Nutrition')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Nutrition'">
    <anihis-nutrition-admin />
  </div>
}

@defer (when loadedTabs().has('First Aid')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'First Aid'">
    <anihis-first-aid-admin />
  </div>
}

@defer (when loadedTabs().has('News')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'News'">
    <anihis-news-admin />
  </div>
}

@defer (when loadedTabs().has('Events')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Events'">
    <anihis-events-admin />
  </div>
}

@defer (when loadedTabs().has('Forum-Topics')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Forum-Topics'">
    <anihis-forum-topics />
  </div>
}

@defer (when loadedTabs().has('Suppliers')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Suppliers'">
    <anihis-suppliers />
  </div>
}

<!-- @defer (when loadedTabs().has('Serial number confirmation')) {
  <div
    class="tab-panel"
    [class.tab-panel--active]="tab === 'Serial number confirmation'"
  >
    <anihis-serial-number-confirmation />
  </div>
} -->

@defer (when loadedTabs().has('Subscription-Plans')) {
  <div class="tab-panel" [class.tab-panel--active]="tab === 'Subscription-Plans'">
    @if (userRole === 'Administrator') {
      <anihis-subscription-plans />
    }
  </div>
}
